module.exports = __webpack_public_path__ + "img/back.15033121.png";